import { Money } from "@workspace/accounting/components";
import { Badge } from "@workspace/ui/components/badge";

import type { TabOrderLine } from "../../types";
import { COMPD_LABEL } from "../comp";

/**
 * HA-658 slice 4 — what a tab's order says about its comps, on Open Tabs and (once the tab is closed) Closed Tabs: Comp'd (£0) for
 * an order that is fully comped, "£X comped" for a part one, nothing for one with none. The figures are the server's.
 */
export function TabOrderCompBadge({ line }: { line: TabOrderLine }) {
	if (line.fullyComped) return <Badge variant="outline">{COMPD_LABEL}</Badge>;

	if (!line.compedAmount || line.compedAmount.value <= 0) return null;

	return (
		<Badge variant="outline">
			<Money {...line.compedAmount} /> comped
		</Badge>
	);
}
